module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 29.f145e596.png";